import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import AppHeader from './layout/AppHeader.jsx';

const NAV = [
  { to: '/workflows/my-approvals', label: 'My Approvals' },
  { to: '/workflows/instances', label: 'All Instances', perm: ['workflow_instance', 'list'] },
  { to: '/workflows/definitions', label: 'Definitions', perm: ['workflow_definition', 'list'] },
  { to: '/workflows/notifications', label: 'Notifications' },
  { to: '/workflows/preferences', label: 'Preferences' },
];

export default function WorkflowShell() {
  const { can, roles } = useAuth();
  const visible = NAV.filter((n) => !n.perm || roles.includes('super_admin') || can(n.perm[0], n.perm[1]));
  return (
    <div className="hr-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Workflow</div>
          <ul>
            {visible.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
